import { useReactiveVar } from '@apollo/client';
import React, { useMemo } from 'react';
import { shoppingCartOffersVar } from '../apollo/reactive-variables/shopping-cart';
import { BulletList } from '../components/lists';
import { formatDayMonthYearSlash } from '../helpers';
import dayjs from '../config/dayjs';
import { INVOICE_FOLIOS } from '../graphql';
import useInvoicesIds from './useInvoicesIds';
import usePlatformAssigneeInfo from './usePlatformAssigneeInfo';

const useExternalOfferShoppingCart = () => {
  const shoppingCartOffers = useReactiveVar(shoppingCartOffersVar);
  const { platformAssigneeInfo } = usePlatformAssigneeInfo();
  const invoiceIds = shoppingCartOffers.map(({ invoiceId }) => invoiceId);
  const { invoices: offers, loading } = useInvoicesIds(invoiceIds, INVOICE_FOLIOS);

  const invoicesFormated = useMemo(
    () => offers?.map(
      ({ folio, id }) => `Folio ${folio} - Fecha de pago: ${formatDayMonthYearSlash(
        dayjs(
          shoppingCartOffers.find(({ invoiceId }) => invoiceId === id)
            .dateToPay,
        ),
      )}`,
    ),
    [offers],
  );

  const paragraphs = useMemo(
    () => [
      {
        id: 1,
        title:
          'Ingresa a tu facturador electrónico y cédenos las siguientes facturas:',
        content: <BulletList list={invoicesFormated} typographyVariant="small_2" />,
      },
      {
        id: 2,
        title: 'Para ceder debes ingresar los siguientes datos:',
        content: <BulletList list={platformAssigneeInfo} typographyVariant="small_2" />,
      },
    ],
    [offers, platformAssigneeInfo],
  );

  return { paragraphs, loading };
};

export default useExternalOfferShoppingCart;
